export const ALL_MANDATORY_2PHOTOS = 'All_Mandatory_2pic';
export const ALL_MANDATORY_3PHOTOS = 'All_Mandatory_3pic';
